import { render, staticRenderFns } from "./UiSlider.vue?vue&type=template&id=05b3feb8"
import script from "./UiSlider.vue?vue&type=script&lang=js"
export * from "./UiSlider.vue?vue&type=script&lang=js"
import style0 from "./UiSlider.vue?vue&type=style&index=0&id=05b3feb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports